import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Traduz um erro da API para a língua do usuário.
 *
 * Por que isto não é luxo: o backend hardcoda as mensagens em pt-BR
 * (_STATUS_TO_MESSAGE_PTBR em app/core/errors.py) e NÃO lê Accept-Language.
 * Exibir `error.message` cru daria um app em inglês falando português.
 *
 * O `code` é o contrato estável (47 códigos canônicos extraídos das chamadas a
 * ApiError no backend); a `message` é o fallback — pior que uma tradução, melhor
 * que um código cru na tela.
 */
export function useApiErrorMessage(): (error: unknown) => string {
  const { t } = useTranslation('errors')

  return useCallback(
    (error: unknown) => {
      if (error instanceof Error && 'code' in error && typeof error.code === 'string') {
        // O code vem do servidor em runtime — um código novo que o backend
        // introduza não está no mapa tipado. É exatamente o caso do defaultValue:
        // cair na mensagem pt-BR do servidor em vez de quebrar ou mostrar o code.
        const fallback = error.message || t('unknown')
        return t(error.code, { defaultValue: fallback })
      }
      return t('unknown')
    },
    [t],
  )
}
